import rollbar from '~/vendor/rollbar';
import {createAction} from 'redux-actions';
import {
  getCategories,
  getFonts,
  getFontSearchAutofillData
} from '~/selectors/FontSelectors';
// constants
import remoteServices from '~/constants/RemoteServices';
import FontTypes from '~/constants/types/FontTypes';
import deserializeFonts from '~/data/deserializers/font';
import {setDefaultFont} from '~/utils/icon';

export const fontIsClickedFromDropdown = createAction(
  FontTypes.FONT_IS_CLICKED_FROM_DROPDOWN
);

export const loadFontSearchHistory = createAction(
  FontTypes.LOAD_FONT_SEARCH_HISTORY
);

export const updateFontSearchHistory = createAction(
  FontTypes.UPDATE_FONT_SEARCH_HISTORY
);

const loadingResults = createAction(FontTypes.LOADING_RESULTS);

export const setScrollToFont = createAction(FontTypes.SET_SCROLL_TO_FONT);

const categoryLoaded = createAction(
  FontTypes.CATEGORY_LOADED,
  undefined,
  ({category}) => ({fontCategory: category})
);

function categoryFailed(error) {
  rollbar.warn('External Service Failure: Font Category', error);
  return {
    type: FontTypes.CATEGORY_FAILED,
    payload: error,
    error: true
  };
}

const categoriesLoaded = createAction(
  FontTypes.CATEGORIES_LOADED,
  undefined,
  () => undefined
);

const previousCategory = createAction(
  FontTypes.UPDATE_PREVIOUS_CATEGORY,
  undefined,
  ({category}) => ({fontCategory: category})
);

function categoriesFailed(error) {
  rollbar.warn('External Service Failure: Font Categories', error);
  return {
    type: FontTypes.CATEGORIES_FAILED,
    payload: error,
    error: true
  };
}

export function updatePreviousCategory({cat}) {
  return dispatch => {
    return dispatch(previousCategory({category: cat}));
  };
}

export function category({cat}) {
  return (dispatch, getState) => {
    const state = getState();
    const category = getFonts(state).get(cat);
    if (category && category.length > 0) return Promise.resolve(true);
    dispatch(loadingResults());

    const url = remoteServices.fonts + `/1.json?name=${cat}`;
    return window
      .fetch(url)
      .then(response => {
        if (response.ok) {
          return response.json().then(data => {
            dispatch(
              categoryLoaded({
                category: cat,
                resource: deserializeFonts(data)
              })
            );
          });
        } else {
          return dispatch(categoryFailed(response));
        }
      })
      .catch(error => dispatch(categoryFailed(error)));
  };
}

export function categories() {
  return (dispatch, getState) => {
    const state = getState();
    const categories = getCategories(state);
    // E.g categories object
    // {All: 399, Brush: 49, Collegiate: 25, ...}
    if (categories['All'] > 0) return;
    dispatch(loadingResults());

    const url = remoteServices.fonts;

    return window
      .fetch(url)
      .then(response => {
        if (response.ok) {
          return response
            .json()
            .then(data => dispatch(categoriesLoaded({resource: data})));
        } else {
          return dispatch(categoriesFailed(response));
        }
      })
      .catch(error => dispatch(categoriesFailed(error)));
  };
}

export function loadFontAutofillData() {
  return (dispatch, getState) => {
    const state = getState();
    const url = remoteServices.fonts;
    let fontAutofillData = getFontSearchAutofillData(state);

    if (!fontAutofillData.length) {
      const fetchCategories = window.fetch(url).then(response => {
        return response.json();
      });
      const fetchFonts = window
        .fetch(url + '/1.json?name=All')
        .then(response => {
          return response.json();
        });

      Promise.all([fetchCategories, fetchFonts]).then(([categories, fonts]) => {
        setDefaultFont();

        Object.keys(categories).map(cat => {
          fontAutofillData.push({fontCategory: cat});
        });

        fontAutofillData = [...fontAutofillData, ...fonts];

        return dispatch({
          type: FontTypes.FONT_AUTOFILL_DATA_LOADED,
          payload: fontAutofillData
        });
      });
    }
  };
}
